import { createBrowserRouter, Navigate } from "react-router-dom";
import RootLayout from "./utils/RootLayout";
import SignIn from "./pages/Login/SignIn";
import SelectProject from "./pages/SelectProject/SelectProject";
import Home from "./pages/Home/Home";
import Curation from "./pages/Curation/Curation";
import Manager from "./pages/Manager/Manager";
import { APPLICATION_NAME } from "./utils/Constant";

export const routers = createBrowserRouter([
  {
    path: `/${APPLICATION_NAME}`,
    element: <RootLayout />,
    children: [
      {
        index: true,
        element: <Navigate to={`/${APPLICATION_NAME}/login`} replace />,
      },
      {
        path: "login",
        element: <SignIn />,
      },
      {
        path: "select-project",
        element: <SelectProject />,
      },
      {
        path: "home",
        element: <Home />,
      },
      {
        path: "curation",
        element: <Curation />,
      },
      {
        path: "manager",
        element: <Manager />,
      },
    ],
  },
]);
